import * as jose from 'jose';
import * as lodash from 'lodash';

// decode accesstoken and return entitlements
export default function formatEntitlements(accessToken: string) {
  const payloadContent = accessToken ? jose.decodeJwt(accessToken) : null;
  if (payloadContent && 'entitlements' in payloadContent) {
    return payloadContent['entitlements' as keyof typeof payloadContent];
  }
  return payloadContent;
}

// decode token and return XsrfToken
export function getXsrfTokenFromJwt(token: string): string {
  const payload = token.split('.')[1];
  const payloadContent = JSON.parse(window.atob(payload));
  return payloadContent.xsrfToken;
}

// extract itps entitlements and return entitlement keys ( ex: itps: dark_web => dark_web)
export function formatUserFeatures(entitlements: unknown): string[] {
  const formattedUserFeatures: string[] = [];
  if (!entitlements) return [];
  Object.entries(entitlements).forEach(([key, value]) => {
    if (lodash.isArray(value)) {
      formattedUserFeatures.push(...value);
    } else if (lodash.isBoolean(value)) {
      const feature = key.split(':')[1];
      formattedUserFeatures.push(feature);
    } else if (lodash.isString()) {
      formattedUserFeatures.push(value);
    }
  });
  return formattedUserFeatures;
}

export function getAgentIdFromAccessToken(accessToken: string): string | null {
  if (!accessToken) return null;
  const payload = jose.decodeJwt(accessToken);
  return (payload?.agent_name as string) ?? null;
}

export function getUserIdFromAccessToken(
  accessToken: string,
): string | undefined {
  if (!accessToken) return undefined;
  const payload = jose.decodeJwt(accessToken);
  return payload.sub as string;
}

export function isValidDate(d: any) {
  if (Object.prototype.toString.call(d) === '[object Date]') {
    if (!Number.isNaN(d.getTime())) {
      return true;
    }
    return false;
  }
  return false;
}
